import { render, staticRenderFns } from "./detailImportBatchList.vue?vue&type=template&id=0d8dcb3e&scoped=true&"
import script from "./detailImportBatchList.vue?vue&type=script&lang=js&"
export * from "./detailImportBatchList.vue?vue&type=script&lang=js&"
import style0 from "./detailImportBatchList.vue?vue&type=style&index=0&id=0d8dcb3e&scoped=true&lang=css&"
import style1 from "./detailImportBatchList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8dcb3e",
  null
  
)

export default component.exports